
import React from 'react';
import rep from './styling/images/repairing_service_contracts/repairing_service_contracts.jpg';

const RepairingAndServiceContracts = () => {
  
    
  return <div>
    <div>
        <style>
        {`
        .auth_cert {
            display: flex;
            flex-direction: column;
            font-family: 'Arial', sans-serif;
            color: #333;
            margin: 0 8%;
            padding: 20px;
            max-width: 80%;
            border-radius: 8px;
            position: relative;
        }
        .heading {
            font-size: 32px;
            word-spacing: 5px;
            font-weight: bold;
            color: black;
            text-align: center;
            margin-bottom: 5%;
        }
          
        .auth_img{
            margin-bottom: 5%;
        }
        .row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5%;
            margin-left: 40px;
            margin-right: 40px;
            flex-wrap: wrap;
            font-size: 18px;
            line-height: 1.6;
}
            .row p{
            margin-bottom:2px;
            margin-top:2px;
            text-align: justify;
          }
          
           @media (max-width: 768px) {
              .auth_cert {
                  margin: 0 4%;
                  padding: 15px;
                  max-width: 90%;
              }

              .heading {
                  font-size: 24px;
              }

              .row {
                  margin-left: 20px;
                  margin-right: 20px;
                  font-size: 14px;
              }
          }

          /* Responsive for mobile */
          @media (max-width: 480px) {
              .auth_cert {
                  margin: 0 2%;
                  padding: 10px;
                  max-width: 100%;
              }

              .heading {
                  font-size: 18px;
                  margin-bottom: 3%;
              }

              .row {
                  margin-left: 10px;
                  margin-right: 10px;
                  font-size: 12px;
                  text-align: center;
              }

              .auth_img {
                  width: 100%;
                  height: auto;
                  margin-bottom: 10%;
              }

              .row p {
                  margin-bottom: 8px;
              }
          }
            `}
        </style>
    </div>
    <div className='auth_cert'>
      <h1 className='heading'>REPAIRING & SERVICE CONTRACTS</h1>
    <img className="auth_img" src={rep} alt="" />
    <div className="row">
    <p>In addition to our sales services, we offer comprehensive repair and service contracts, available on a yearly or quarterly basis. Through these contracts, we ensure that our clients receive regular maintenance and repair services at their doorstep or on-site, providing convenience and peace of mind.</p>
    </div>
     <div className="row">
     <p>Our service contracts eliminate the hassle of scheduling or reminding us for timely maintenance. Whether the equipment is from our own brand or any other, we guarantee prompt and professional repair and servicing, tailored to each client's needs.</p>
     </div>
    <div className='row'>
    <p>This service is especially valuable for our corporate and industrial clients, as the proper functioning of their equipment directly impacts their operations. With a customer-first approach and uncompromising standards, we stand out in the market for delivering reliable, high-quality service.</p>
    </div>
    </div>
  </div>;
};

export default RepairingAndServiceContracts;

